import { icons } from "~/assets";

export const medalsIcons = {
  BRONZE: icons.bronzeMedal,
  PRATA: icons.silverMedal,
  OURO: icons.goldMedal,
  PLATINUM: icons.platinum0,
  PLATINUM_1: icons.platinum1,
  PLATINUM_2: icons.platinum2,
  PLATINUM_3: icons.platinum3,
};

export interface IResponseDownloadCSV {
  base64: string;
  filename: string;
}

export interface IDialogInfo {
  open: boolean;
  message: string;
  error: boolean;
  isGoBack: boolean;
}

export interface IResponseCustomerData {
  cpf: string;
  nomeCompleto: string;
  celular: string;
  numeroCartao: string;
  email: string;
  bairro: string;
  uf: string;
  cidade: string;
  statusCartao: string;
  nivel: string;
  limiteDisponivel: number;
  insertedManually?: boolean;
}

export interface IResponseCustomerDataPaginated {
  data: IResponseCustomerData[];
  page: number;
  pageSize: number;
  totalPages: number;
  totalSize: number;
}

export interface ICustomer {
  limitePorPagina: number;
  pagina: Array<{
    bairro: string;
    celular: string;
    cidade: string;
    cpf: string;
    email: string;
    inseridoManualmente: boolean;
    limiteDisponivel: number;
    nivel: string | null;
    nomeCompleto: string;
    numeroCartao: string;
    statusCartao: string;
    uf: string;
  }>;
  paginaAtual: number;
  totalDePaginas: number;
  totalItens: number;
}

export interface IResponseDetailsCampaing {
  id: string;
  criterioPesquisa: {
    baseDados: string;
    segmentacoes: string[];
    filtrosPesquisa: {
      estados: string[];
      cidades: string[];
      bairros: string[];
      statusCartao: string[];
      rangeLimiteDisponivel: number[];
    };
  };
  dataValidade: string;
  dataAgendamento: string | null;
  canal: string | null;
  tipo: string;
  status: string;
  nome: string;
  totalAtingidos: number;
  isManual: boolean;
  templateMensagem: {
    titulo: string;
    mensagem: string;
  };
}